module.exports = __webpack_public_path__ + "img/threedots.b5876c52.svg";